module.exports = __webpack_public_path__ + "assets/img/btn-detail-8f5ed834.png";